<template>
<section class="data-overview-wrapper">
  <section class="real-aqi-panel-wrapper">
    <real-aqi-panel />
  </section>

  <section class="real-site-device-info-wrapper">
    <real-site-device-info-map />
  </section>
</section>
</template>

<script>
import BaseStore from '../../components/BaseStore'
import RealAqiPanel from './RealAqiPanel'
import RealSiteDeviceInfoMap from './RealSiteDeviceInfoMap'
import EventKey from './EventKey'

export default {
  name: 'Home',
  extends: BaseStore,
  components: {RealSiteDeviceInfoMap, RealAqiPanel},
  routeInfo: {
    label: '数据概览'
  },
  methods: {
    getRealData (isFirst) {
      this.$nextTick(() => {
        this.$eventBus.emit(EventKey.REAL_QUERY, isFirst)
      })
    },
    clearCalcTimeTimer () {
      clearTimeout(this.timeTimer)
    },
    updateTimeTimer () {
      const MINUTE_STEP = 10

      let now = new Date()
      let nowTS = now.getTime()
      let currentMinutes = now.getMinutes()

      now.setMinutes(currentMinutes + (MINUTE_STEP - (currentMinutes % MINUTE_STEP)) + 1, 0, 0)

      this.timeTimer = setTimeout(() => {
        this.getRealData()
        this.updateTimeTimer()
      }, now.getTime() - nowTS)
    }
  },
  created () {
    this.updateTimeTimer()
  },
  beforeDestroy () {
    this.clearCalcTimeTimer()
  },
  watch: {
    profileSiteDevices: {
      immediate: true,
      handler (profileSiteDevices) {
        this.getRealData(true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-overview-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  > .real-aqi-panel-wrapper {
    position: absolute;
    top: 20px;
    left: 10px;
    z-index: 1;
    pointer-events: none;
  }

  > .real-site-device-info-wrapper {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/01Data-Overview/index.vue